module.exports = __webpack_public_path__ + "static/media/payment_logo.a8a48814.jpg";